import { render, staticRenderFns } from "./WebshopCart.vue?vue&type=template&id=67befe53&scoped=true&"
import script from "./WebshopCart.vue?vue&type=script&lang=js&"
export * from "./WebshopCart.vue?vue&type=script&lang=js&"
import style0 from "./WebshopCart.vue?vue&type=style&index=0&id=67befe53&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67befe53",
  null
  
)

export default component.exports